import { useRef } from 'react';
import { services } from '../data/services';
import { SiteHeader, SiteFooter, ProofList } from '../components/Chrome';
import { InquiryForm } from '../components/InquiryForm';
import { useTypingPlaceholder } from '../hooks/useTypingPlaceholder';

function HeroTicket() {
  const ticketRef = useRef(null);
  const text = useTypingPlaceholder(true, ticketRef);
  return (
    <a ref={ticketRef} className="bs-input hero-ticket hero-ticket--selected" href="#inquiry" aria-label="Tell us your problem">
      <span className="hero-ticket-prompt" aria-hidden="true">$</span>
      <span className="hero-ticket-ph">{text}</span>
      <span className="hero-ticket-go" aria-hidden="true">→</span>
    </a>
  );
}

function ServicesMarquee() {
  const cards = (duplicate = false) => services.map((service) => (
    <a
      className="svc-card"
      key={`${duplicate ? 'duplicate-' : ''}${service.id}`}
      href={`/services/${service.id}/`}
      aria-hidden={duplicate ? 'true' : undefined}
      tabIndex={duplicate ? -1 : undefined}
    >
      <h3><span>{service.name}</span><span className="svc-arrow" aria-hidden="true">→</span></h3>
      <p>{service.card}</p>
    </a>
  ));
  return (
    <section className="site-wrap section hairline-top">
      <div className="section-head">
        <h2>Frequent fliers</h2>
        <a className="section-link" href="/services/">All services →</a>
      </div>
      <div className="svc-marquee"><div className="svc-track">{cards()}{cards(true)}</div></div>
    </section>
  );
}

export function HomePage() {
  return (
    <>
      <SiteHeader active="home" />
      <main>
        <section className="site-wrap hero">
          <h1>Byte-size solutions for <span className="highlight">small business</span> problems.</h1>
          <p className="hero-sub">Friendly, local problem-solvers. Plain answers, fair prices — on-site across the Sutherland Shire, remote anywhere.</p>
          <div className="hero-ctas"><HeroTicket /></div>
          <p className="fine-muted hero-fine">No problem too small or too silly — we have heard way sillier.</p>
        </section>

        <section className="band-soft">
          <div className="site-wrap pos-grid">
            <div>
              <h2>We solve problems, not computers.</h2>
              <p>You do not need to know whether it is a website thing, a Wi-Fi thing or a spreadsheet thing. Working that out is our job. Bring the problem; we will find the shortest path to solved.</p>
            </div>
            <ProofList />
          </div>
        </section>

        <section className="site-wrap section">
          <div className="section-head"><h2>How it works</h2></div>
          <div className="steps-grid">
            <div className="step"><span className="step-num step-num--1">01</span><h3>Tell us the problem</h3><p>Plain words are perfect. You do not need to diagnose it or prepare anything.</p></div>
            <div className="step"><span className="step-num step-num--2">02</span><h3>We work out the next step</h3><p>I review the details, ask any useful questions and explain the sensible options.</p></div>
            <div className="step"><span className="step-num step-num--3">03</span><h3>It gets solved</h3><p>We agree on the work, get it done and make sure you understand what changed.</p></div>
          </div>
        </section>

        <ServicesMarquee />

        <section id="inquiry" className="band-soft">
          <div className="site-wrap inquiry-grid">
            <div className="inquiry-pitch">
              <div className="overline">Start here</div>
              <h2>Tell us the problem.</h2>
              <p>Describe what is slowing the business down. It does not need to sound technical, and you do not need to know the solution.</p>
              <ProofList />
            </div>
            <InquiryForm />
          </div>
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
